/*
 * toolboxlijst.ts
 * Gegenereerd met Junie (AI), 25-5-2026 - Jelmer Jellema - Spin in het Web B.V.
 * Toolboxlijst-scherm: overzicht van alle toolbox-documenten.
 */

import {Component} from '@angular/core';
import {Datatable2scherm} from '../abstracts/datatable2scherm.class';
import {DatatableDef} from 'sihw-ng/datatable2/datatable2.component';
import {SihwDatatable2Module} from 'sihw-ng/datatable2/datatable2.module';
import {Toolbox} from '../../models/toolbox';
import {Functie} from '../../models/functie';
import {PersoneelvastToolbox} from '../../models/personeelvast_toolbox';
import {XlsDatatable} from 'sihw-ng/xlsx-datatable/xls-datatable';

@Component({
  standalone: true,
  selector: 'toolboxlijst',
  templateUrl: './toolboxlijst.html',
  styleUrls: ['./toolboxlijst.scss'],
  imports: [
    SihwDatatable2Module,
    XlsDatatable
  ]
})
export class Toolboxlijst extends Datatable2scherm {
  _starttitle = 'Toolbox';
  icon = 'fas fa-toolbox';

  editscherm = 'Toolboxedit';
  model = Toolbox;
  tableQuery = Toolbox.recordquery([PersoneelvastToolbox], [
    [Toolbox, {order: [['begindatum', 'desc']]}],
    [PersoneelvastToolbox, {attributes: ['id'], where: {geaccepteerd: true}, required: false}],
  ]);

  public readonly tableDefinition: DatatableDef = {
    track: 'id',
    standaardsortering: {
      key: 'begindatum',
      richting: -1
    },
    velden: {
      titel: {
        label: 'Titel',
        type: 'string'
      },
      actief: {
        label: 'Actief',
        type: 'bool',
        standaardfilter: 1
      },
      begindatum: {
        label: 'Begindatum',
        type: ['moment', {format: 'DD-MM-YYYY'}]
      },
      einddatum: {
        label: 'Einddatum',
        type: ['moment', {format: 'DD-MM-YYYY'}]
      },
      functie_ids: {
        label: 'Functies',
        type: 'string',
        format: ids => ids.join(', ')
      },
      labels: {
        label: 'Labels',
        format: ids => ids.join(', ')
      },
      aantal_geaccepteerd: {
        label: 'Geaccepteerd',
        type: 'number'
      }
    }
  };

  constructor() {
    super();
  }

  protected override async afterHaaldata(): Promise<void> {
    const functieLookup = await Functie.getLookup(Toolbox);
    this.tableData = (this.tableData as Toolbox[]).map((rij: any) => ({
      ...rij,
      functie_ids: (rij.functie_ids ?? []).map((id: number) => functieLookup[id]?.naam ?? String(id)),
      aantal_geaccepteerd: rij.personeelvast_toolbox?.length ?? 0
    }));
  }
}

Toolboxlijst.register('Toolboxlijst');
